const Storage = require("./Storage");

const STAFF_BYPASS_STORAGE_KEY = "ipl-staff-block-bypass";

const hasStaffBypass = function() {
	return Storage.getStorage().getItem(STAFF_BYPASS_STORAGE_KEY) === "1";
};

const setStaffBypass = function() {
	Storage.getStorage().setItem(STAFF_BYPASS_STORAGE_KEY, "1");
};

const clearStaffBypass = function() {
	Storage.getStorage().removeItem(STAFF_BYPASS_STORAGE_KEY);
};

module.exports = {
	STAFF_BYPASS_STORAGE_KEY,
	hasStaffBypass,
	setStaffBypass,
	clearStaffBypass,
};
